import { useRef, useState} from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import {PanelBody,RangeControl,Button,__experimentalToggleGroupControl as ToggleGroupControl,
    __experimentalToggleGroupControlOption as ToggleGroupControlOption,
} from '@wordpress/components';
import {MediaUpload} from '@wordpress/block-editor';
import {parseUploadedMediaAndSetIcon,flattenIconsArray} from '../../utils';
import { applyFilters } from '@wordpress/hooks';
import {CustomInserterModal,InserterModal as Inserter} from '../../components';
import { defaultIcon } from '../../icons/default';
import getIcons from '../../icons';
import { VayuBlocksBackground, VayuBlocksAlignment,VayuBlocksAnimation,VayuBlocksTypography,
    VayuBlocksTextControl,VayuBlocksToggleControl,HeightControl } from '@vayu-blocks';
import {VideoIconSelector} from './video-icon-selector.js';
import {Layouts} from './layouts.js';

const Icon = ({ attributes, setAttributes, openPanels, onTogglePanel }) => {

    const {iconName} = attributes;

    const [isInserterOpen, setInserterOpen] = useState(false);
    const [isCustomInserterOpen, setCustomInserterOpen] = useState(false);

    const iconsAll = flattenIconsArray(getIcons());
    const namedIcon = iconsAll.find((i) => i.name === iconName);
    const printedIcon = namedIcon?.icon || defaultIcon;
    // Ref for media upload
    const mediaOpenRef = useRef();

    // Markup for the icon
    const iconMarkup = (
        <div className="box-icon" onClick={() => setInserterOpen(true)}>
            <div
                className="vayu_blocks_icon_block_post_setting_icon"

                {...(attributes.iconName === 'medf' && attributes.mediaIcon
				? { dangerouslySetInnerHTML: { __html: attributes.mediaIcon } }
				: {})}
            />

            {attributes.iconName !== 'medf' && printedIcon}

            <div onClick={(e) => e.stopPropagation()}>
                <Button style={{ width: '30%', left: '1%' }} onClick={() => setInserterOpen(true)}>
                    Library
                </Button>

                <Button
                    style={{ width: '30%', left: '35%' }}
                    onClick={() => {
                        if (mediaOpenRef.current) {
                            mediaOpenRef.current();
                        }
                    }}
                >
                    Media
                </Button>

                <Button style={{ width: '30%', left: '69%' }} onClick={() => setCustomInserterOpen(true)}>
                    Custom
                </Button>
            </div>
        </div>
    );

    // Handle click to update the rotate value
    const handleRotationClick = (value) => {
        setAttributes({ rotate: value });
    };

    // Allow users to disable custom SVG icons
    const enableCustomIcons = applyFilters('iconBlock.enableCustomIcons', true);

    const renderRotatingIcon = (angle, attributes, handleRotationClick, printedIcon) => {
        const isMediaIcon = attributes.iconName === 'medf' && attributes.mediaIcon;

        return (
            <a
                key={angle}
                className={`vayu_blocks_rotation_div_a_tag vayu_blcoks_rotate_${angle}_degree ${
                    attributes.rotate === angle ? 'vayu_blocks_clicked_a_tag' : ''
                }`}
                onClick={() => handleRotationClick(angle)}
            >
                {isMediaIcon ? (
                    <div
                        className="vayu_blocks_rotation_div_div_inside"
                        dangerouslySetInnerHTML={{ __html: attributes.mediaIcon }}
                    />
                ) : (
                    <div className="vayu_blocks_rotation_div_div_inside">
                        {printedIcon}
                    </div>
                )}
            </a>
        );
    };

    return (

        <>
            <PanelBody 
                title={__('layouts', 'vayu-blocks')} 
                opened={openPanels['slide-layout']}
                onToggle={() => onTogglePanel('slide-layout')} >

                <Layouts
                    setAttributes={setAttributes}
                    attributes={attributes}
                />

            </PanelBody>

            <PanelBody 
                title={__('Icon', 'vayu-blocks')} 
                opened={openPanels['slide-title']}
                onToggle={() => onTogglePanel('slide-title')} 
            >
                {attributes.parentBlock != 'vayu-blocks/video' ? (
                    <div className='vayu_blocks_icon_block_post_setting_inserter' >
                        {!iconName ? (
                            <div className='vayu_blocks_icon_block_post_setting' >
                                Icon
                            </div>
                        ) : (
                            iconMarkup
                        )}

                        <Inserter
                            isInserterOpen={isInserterOpen}
                            setInserterOpen={setInserterOpen}
                            attributes={attributes}
                            setAttributes={setAttributes}
                        />

                        <MediaUpload
                            onSelect={(media) => {
                                parseUploadedMediaAndSetIcon(media, attributes, setAttributes);
                            }}
                            allowedTypes={['image/svg+xml']}
                            render={({ open }) => {
                                mediaOpenRef.current = open; // save the open function
                                return null; // don't render UI
                            }}
                        />

                        { enableCustomIcons && (
                            <CustomInserterModal
                                isCustomInserterOpen={ isCustomInserterOpen }
                                setCustomInserterOpen={ setCustomInserterOpen }
                                attributes={ attributes }
                                setAttributes={ setAttributes }
                            />
                        )}
                        
                    </div>
                ):(
                   <VideoIconSelector 
                        animationData={(attributes.iconName || '').replace(/^wordpress-/, '')}
                        onChange={(aname) => setAttributes({ iconName: `wordpress-${aname}` })}
                    />
                )}

                <div className="vayu_blocks_rotation_div">
                    {[0, 90, 180, 270].map((angle) =>
                        renderRotatingIcon(angle, attributes, handleRotationClick, printedIcon)
                    )}
                </div>


                <br/>

                <RangeControl
                    initialPosition={0}
                    label="Rotate"
                    max={360}
                    min={0}
                    value={attributes.rotate}
                    onChange={(value) => setAttributes({rotate:value})}
                />

                {attributes.parentBlock !== 'vayu-blocks/image-hotspot' && (
                    <>
                        <VayuBlocksAlignment
                            onChange={(key,value)=>setAttributes({[key]:value})}
                            setAttributes={setAttributes}
                            alignment = {{key:'alignment',value:attributes.alignment}}
                        />
                        <br/>
                        {attributes.parentBlock != 'vayu-blocks/video' && ( 
                            <>
                                <label htmlFor="accessibility-mode">{__('Accessibility Mode', 'vayu-blocks')}</label>

                                <ToggleGroupControl
                                    value={ attributes.mode }
                                    isBlock
                                    __nextHasNoMarginBottom={true}
                                    __next40pxDefaultSize={true}
                                    onChange={ (value)=>setAttributes({mode:value}) }
                                    >
                                    <ToggleGroupControlOption value="graphics-symbol" label={__('SVG', 'vayu-blocks')} />
                                    <ToggleGroupControlOption value="image" label={__('Image', 'vayu-blocks')} />
                                    <ToggleGroupControlOption value="decorative" label={__('Decorative', 'vayu-blocks')} />
                                </ToggleGroupControl>
                                
                                {attributes.mode != 'decorative' ? (
                                    <>  
                                        <VayuBlocksTextControl
                                            label={__('Accessibility Label', 'vayu-blocks')}
                                            placeholder='Alt Text...'
                                            onChange={(value)=>setAttributes({textmode:value})}
                                            value={attributes.textmode}
                                        />
                                    </>
                                ) : (
                                    <p>{__('Accessibility Label is not applicable for Decorative mode', 'vayu-blocks')}</p>
                                )}
                            </>
                        )}
                    </>
                )}
            </PanelBody>

            {attributes.parentBlock != 'vayu-blocks/video' && (
                <PanelBody 
                    title={__('Text', 'vayu-blocks')} 
                    opened={openPanels['slide-text']}
                    onToggle={() => onTogglePanel('slide-text')} >

                    <VayuBlocksToggleControl
                        label={__('Text', 'vayu-blocks')}
                        checked={attributes.icontextallow}
                        onChange={(value)=> setAttributes({icontextallow:value})}
                    />

                    {attributes.icontextallow && (
                        <>

                            <VayuBlocksTextControl
                                placeholder='Text...'
                                onChange={(value)=>setAttributes({icontxt:value})}
                                value={attributes.icontxt}
                            />

                            <HeightControl 
                                label={__('Top', 'vayu-blocks')}
                                value={ attributes.textx }
                                onChange={ (value)=>setAttributes({textx:value}) }
                            />
                            <br/>
                            <HeightControl 
                                label={__('Left', 'vayu-blocks')}
                                value={ attributes.texty }
                                onChange={ (value)=>setAttributes({texty:value}) }
                            />
                                <br/>

                            <VayuBlocksBackground
                                onChange={(key,value)=>setAttributes({[key]:value})}
                                colorPanel = {[
                                    {
                                        active: ['color'],
                                        label: 'Text',
                                        key:'textcolor',
                                        value:attributes.textcolor,
                                    },
                                    {
                                        active: ['color'],
                                        label: 'Hover',
                                        key:'textcolorhover',
                                        value:attributes.textcolorhover,
                                    },
                                    {
                                        active: ['color'],
                                        label: 'Text Stroke',
                                        key:'stroketext',
                                        value:attributes.stroketext,
                                    },
                                ]}
                            />

                            <RangeControl
                                label={__('Stroke Width', 'vayu-blocks')}
                                __next40pxDefaultSize={true}
                                __nextHasNoMarginBottom={true}
                                max={12}
                                min={0}
                                step={1}
                                value={attributes.strokeWidthtext}
                                marks
                                onChange={(value)=> setAttributes({strokeWidthtext:value})}
                            />

                            <VayuBlocksTypography
                                value={attributes.typography}
                                onChange={(newValues) => {setAttributes({typography:newValues})}}
                            />

                        </>
                    )}
                </PanelBody>
            )}

            <PanelBody 
                title={__('Icon Animation', 'vayu-blocks')} 
                opened={openPanels['slide-animation']}
                onToggle={() => onTogglePanel('slide-animation')} 
            >

                <VayuBlocksAnimation
                    animationData={attributes.animationData}
                    onChange={(key, value) => {setAttributes({ [key]: value });}}
                    dataKey="animationData"
                />

            </PanelBody>
        </>

    );
};

export default Icon;